import { useState } from "react";
import ChatPage from "./pages/ChatPage";
import PlannerPage from "./pages/PlannerPage";
import FloorPlanPage from "./pages/FloorPlanPage";
import DefectScannerPage from "./pages/DefectScannerPage";
import BrandContractPage from "./pages/BrandContractPage";
import EstimatePage from "./pages/EstimatePage";
import VastuPage from "./pages/VastuPage";
import LoanPage from "./pages/LoanPage";
import KnowledgePage from "./pages/KnowledgePage";
import Sidebar from "./components/Sidebar";
import ServerStatusBanner from "./components/ServerStatusBanner";
import "./styles/global.css";

export default function App() {
  const [activePage, setActivePage] = useState("chat");
  const [sessionId] = useState(() => crypto.randomUUID());
  const [chatInitialPrompt, setChatInitialPrompt] = useState("");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleAskAI = (promptText) => {
    setChatInitialPrompt(promptText);
    setActivePage("chat");
  };

  return (
    <div className="app-shell">
      {/* Mobile top navbar */}
      <div className="mobile-header-bar">
        <button className="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen(true)}>
          ☰
        </button>
        <div className="mobile-brand-title">
          <span>🏗️</span> NirmanAI Pro
        </div>
        <div className="mobile-page-pill">{activePage.toUpperCase()}</div>
      </div>

      <Sidebar
        activePage={activePage}
        onNavigate={(page) => {
          setActivePage(page);
          if (page !== "chat") setChatInitialPrompt("");
        }}
        isMobileOpen={isMobileMenuOpen}
        onCloseMobile={() => setIsMobileMenuOpen(false)}
      />

      <main className="main-content">
        <ServerStatusBanner />
        {activePage === "chat" && (
          <ChatPage sessionId={sessionId} initialPrompt={chatInitialPrompt} />
        )}
        {activePage === "planner" && (
          <PlannerPage sessionId={sessionId} onAskAI={handleAskAI} />
        )}
        {activePage === "floorplan" && (
          <FloorPlanPage onAskAI={handleAskAI} />
        )}
        {activePage === "defect" && (
          <DefectScannerPage onAskAI={handleAskAI} />
        )}
        {activePage === "brandcontract" && (
          <BrandContractPage onAskAI={handleAskAI} />
        )}
        {activePage === "estimate" && (
          <EstimatePage onAskAI={handleAskAI} />
        )}
        {activePage === "vastu" && (
          <VastuPage onAskAI={handleAskAI} />
        )}
        {activePage === "loan" && (
          <LoanPage onAskAI={handleAskAI} />
        )}
        {activePage === "knowledge" && (
          <KnowledgePage onAskAI={handleAskAI} />
        )}
      </main>
    </div>
  );
}
